import { render } from "./active-facet-category.vue?vue&type=template&id=3abebb63&scoped=true&ts=true"
import script from "./active-facet-category.vue?vue&type=script&lang=ts"
export * from "./active-facet-category.vue?vue&type=script&lang=ts"

import "./active-facet-category.vue?vue&type=style&index=0&id=3abebb63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abebb63"]])

export default __exports__